'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _BaseIcon2 = require('./BaseIcon');

var _BaseIcon3 = _interopRequireDefault(_BaseIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var Group = function (_BaseIcon) {
  (0, _inherits3.default)(Group, _BaseIcon);

  function Group() {
    (0, _classCallCheck3.default)(this, Group);
    return (0, _possibleConstructorReturn3.default)(this, (Group.__proto__ || (0, _getPrototypeOf2.default)(Group)).apply(this, arguments));
  }

  (0, _createClass3.default)(Group, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'svg',
        this.getSvgProps(),
        _react2.default.createElement('path', (0, _extends3.default)({ d: 'M6.3082 17.4897v-.0067c.0042-.3636.1645-1.506 1.8627-2.545.3104-.4223.5662-.998.827-1.6626.1805-.4598.15-.8518.15-1.41 0-.4125.0776-1.0744-.0245-1.438-.3455-1.2292-1.2177-1.5684-2.24-1.5684-1.0226 0-1.8957.3408-2.2403 1.5722-.1018.3624-.024 1.023-.024 1.4343 0 .5594-.03.9527.151 1.4137.3137.7974.6124 1.4665 1.011 1.8932-1.5523.285-2.6013 1.095-3.3096 1.4105C1.007 17.2357 1 17.951 1 17.951v1.215l5.3082-.001v-1.6753zm10.861-3.819c.5494-.589.966-1.5094 1.3942-2.6004.2485-.6323.2058-1.171.2058-1.9384 0-.567.1066-1.4768-.034-1.9763C18.2605 5.466 17.0622 5 15.6572 5c-1.4058 0-2.6063.4684-3.0795 2.1608-.1396.4982-.0327 1.4057-.0327 1.971 0 .7695-.0417 1.3097.2074 1.943.4312 1.0967.8413 2.0156 1.3895 2.6023-2.1338.392-3.5758 1.505-4.5485 1.9388-2.013.8976-2.023 1.8802-2.023 1.8802v1.6698l16.2114-.0023V17.496s-.01-.9858-2.0304-1.884c-.9788-.435-2.432-1.556-4.5825-1.9412z'
        }, this.getPathProps()))
      );
    }
  }]);
  return Group;
}(_BaseIcon3.default);
/*eslint-enable */


Group.defaultProps = {
  width: 23,
  height: 15,
  viewBox: '1 5 23 15'
};
exports.default = Group;
//# sourceMappingURL=Group.js.map


//////////////////
// WEBPACK FOOTER
// ../icon/lib/Icons/Group.js
// module id = 296
// module chunks = 0